<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      title="地点管理"
      :modal-append-to-body="false"
      width="35%"
      style="margin-top: 180px"
    >
      <div class="container_dialog">
        <div class="left">
          <div class="title">借伞二维码</div>
          <div class="bookcode" id="qrcode" ref="qrcode"></div>
        </div>
        <div class="right">
          <div class="title">还伞二维码</div>
          <div class="bookcode" id="qrcode2" ref="qrcode2"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <template>
          <el-button @click="finished" class="no">取消</el-button>
          <!-- <el-button @click="submit" class="ok"> 提交 </el-button> -->
        </template>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg" class="dialogImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "locationQrcodeDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "1",
    },
    itemList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      shareValue: "",
      shareValue2: "",
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
      if (v) {
        this.shareValue = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww086cfff9688fbdfc&redirect_uri=http://qw.nvc-lighting.com.cn:8088/logistics/borrowingAnUmbrella/borrowingAnUmbrellaApply?id=${this.itemList.id}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect"`;
        this.shareValue2 = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww086cfff9688fbdfc&redirect_uri=http://qw.nvc-lighting.com.cn:8088/logistics/borrowingAnUmbrella?type=2&id=${this.itemList.id}&response_type=code&scope=SCOPE&state=STATE#wechat_redirect"`;
        this.$nextTick(() => {
          this.qrcode();
          this.qrcode2();
        });
      }
    },
  },
  mounted() {},
  methods: {
    // 生成二维码
    qrcode() {
      const qrContainer = document.getElementById("qrcode");
        if (qrContainer) {
          qrContainer.innerHTML = ""; // 清空容器内容
        }
      let qrcode = new QRCode("qrcode", {
        width: 170, //图像宽度
        height: 170, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.L,
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(this.shareValue);
    },
    // 生成二维码2
    qrcode2() {
      const qrContainer = document.getElementById("qrcode2");
        if (qrContainer) {
          qrContainer.innerHTML = ""; // 清空容器内容
        }
      let qrcode = new QRCode("qrcode2", {
        width: 170, //图像宽度
        height: 170, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.L,
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(this.shareValue2);
    },
    // 关闭弹窗
    beforeClose(done) {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      done();
    },
    // 刷新数据
    finished() {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
    submit() {},
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container_dialog {
  padding-left: 50px;
  display: flex;
  flex-wrap: wrap;
  .left,.right{
    width: 50%;
    text-align: center;
    .title{
      font-size: 32px;
      color: #000;
      font-weight: bold;
      margin-bottom: 30px;
    }
    .bookcode{
      display: flex;
      justify-content: center;
    }
  }
}
.dialog-footer {
  .ok {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: #4fa27d;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #fff;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .no {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: none;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #666;
    border: 1px solid #666;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.dialogImg {
  .el-dialog {
    margin-top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    .el-dialog__body {
      height: calc(100vh - 55px);
      overflow: auto;
    }
  }
}
::v-deep {
  .el-dialog {
    margin-top: 0 !important;
    border-radius: 30px;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 150px;
    border-bottom: 1px solid #ccc;
    position: relative;
    .el-dialog__title {
      position: absolute;
      top: 35%;
      left: 50px;
    }
    .el-dialog__headerbtn {
      top: 35%;
      font-size: 40px;
    }
  }
  .el-dialog__body {
    // background: #f7f9fa;
    // height: 75vh;
    // overflow: auto;
    // &::-webkit-scrollbar {
    // display: none;
    // }
  }
}
</style>
